<template>
    <div class="c-m-card c-m-card--with-actions" :class="{'c-m-card--horizontal': horizontalLayout}">
        <router-link v-if="featuredImage" tag="div" class="c-m-card__hero c-m-card__hero--linked" :to="link">
            <lazy-image
                v-if="horizontalLayout"
                :srcset="`${featuredImage.sizes.card_1_1_medium} 960w, ${featuredImage.sizes.card_1_1_small} 480w`"
                :sizes="'(max-width: 480px) 480px, 960px'"
                :src="featuredImage.sizes.card_1_1_medium"
                :alt="altText" />
            <lazy-image
                v-else
                :srcset="`${featuredImage.sizes.card_4_3_x_large} 1440w, ${featuredImage.sizes.card_4_3_large} 1200w, ${featuredImage.sizes.card_4_3_medium} 960w, ${featuredImage.sizes.card_4_3_small} 480w`"
                :sizes="'(max-width: 480px) 480px, (max-width: 960px) 960px, (max-width: 1200px) 1200px, 1440px'"
                :src="featuredImage.sizes.card_4_3_medium"
                :alt="altText" />
        </router-link>
        <router-link v-else tag="div" class="c-m-card__hero c-m-card__hero--linked c-m-card__hero--no-image" :to="link">
            <lazy-image :src="`/assets/images/logo/${defaultImage}`" />
        </router-link>
        <div class="c-m-card__content">
            <div class="c-m-card__headline">
                <h3 class="c-m-card__title"><router-link :to="link">{{title}}</router-link></h3>
            </div>
            <p class="c-m-card__body">{{text}}</p>
        </div>
        <div class="c-m-card__actions">
            <button-link class="c-a-button--circle c-m-card__button" :link="link" :icon="icon" aria-label="Fortsätt"></button-link>
        </div>
    </div>
</template>
<script>
    import filters from '../../../filters/index.js';
    import ButtonLink from '../atoms/AtomButtonLink.vue';
    import LazyImage from '../atoms/LazyImage.vue';

    export default {
        props: [
            'card',
            'horizontalLayout'
        ],
        components: {
            ButtonLink,
            LazyImage
        },
        filters: filters,
        computed: {
            icon: function() {
                return 'arrow_forward'
            },
            defaultImage: function() {
                return 'Brabyggare-logo.png'
            },
            featuredImage: function() {
                return this.card.acf.featured_image ? this.card.acf.featured_image : null
            },
            altText: function() {
                return this.card.acf.featured_image.alt
            },
            title: function() {
                return this.card.post_title
            },
            text: function() {
                return this.card.post_excerpt ? this.card.post_excerpt : filters.truncate(filters.stripHTML(this.card.post_content), 300, true)
            },
            link: function() {
                return `/info/${this.card.post_name}/`
            }
        }
    }

</script>



// WEBPACK FOOTER //
// src/views/components/molecules/MoleculeCardLink.vue